import {Periodo, PeriodoType} from "@commons/types";
import {useAppSelector} from "@hooks/redux-hooks/hooks";
import {selectPeriodo} from "@commons/core.slice";
import {useEffect, useState} from "react";
import {DateTime, Interval} from "luxon";

type Intervallo = { valid: boolean, start?: string, end?: string, format: string }
export const useIntervallo = (intervalloSelezionato: PeriodoType = 'all', dataDa: string, dataA: string, format: string = 'yyyyLLdd'): Intervallo => {
    const pariodoEnvironment: Periodo = useAppSelector(selectPeriodo);
    const [intervallo, setIntervallo] = useState<Intervallo>({valid: false, format: ''});
    useEffect(() => {

        const today = DateTime.now();
        //const today = DateTime.fromISO('20241231');

        const setupIntervallo = (intervalli: Interval[]): Interval | undefined => {
            let result;
            for (let index = 0; index < intervalli.length; ++index) {
                const intervallo = intervalli[index];
                if (intervallo.contains(today)) {
                    //console.log(intervallo.start!.toFormat('dd/LL/yyyy'))
                    //console.log(intervallo.end!.toFormat('dd/LL/yyyy'))
                    if (index === intervalli.length - 1) {
                        result = Interval.fromDateTimes(intervallo.start!, intervallo.end!);
                        break;
                    } else {
                        result = Interval.fromDateTimes(intervallo.start!, intervallo.end!.minus({day: 1}));
                        break;
                    }
                }
            }
            return result;
        }

        const periodoPredefinito = pariodoEnvironment ? DateTime.fromObject({year: pariodoEnvironment.anno, month: pariodoEnvironment.mese}).startOf('month') : today;
        const primoGennaio = DateTime.now().startOf('year');
        const fineAnno = DateTime.now().endOf('year');
        let intervallo: Interval | undefined = Interval.fromDateTimes(primoGennaio, fineAnno);

        switch (intervalloSelezionato) {
            case 'today':
                intervallo = Interval.fromDateTimes(today, today);
                break;
            case 'm':
                intervallo = Interval.fromDateTimes(today.startOf('month'), today.endOf('month'));
                break;
            case 'b':
                intervallo = setupIntervallo(intervallo.splitBy({months: 2}));
                break;
            case 't':
                intervallo = setupIntervallo(intervallo.splitBy({months: 3}));
                break;
            case 'q':
                intervallo = setupIntervallo(intervallo.splitBy({months: 4}));
                break;
            case 's':
                intervallo = setupIntervallo(intervallo.splitBy({months: 6}));
                break;
            case 'p':
                intervallo = Interval.fromDateTimes(periodoPredefinito.startOf('month'), periodoPredefinito.endOf('month'));
                break;

            case 'cy':
                break;
            case 'fy':
                break;

            case 'all':
                intervallo = undefined;
                break;

            default:
                intervallo = Interval.fromDateTimes(DateTime.fromFormat(dataDa, format), DateTime.fromFormat(dataA, format));
                break;
        }
        const valid=!!intervallo && !!intervallo.start && !!intervallo!.end;
        setIntervallo({
            valid ,
            start: valid ? intervallo!.start!.toFormat(format) : undefined,
            end: valid ? intervallo!.end!.toFormat(format) : undefined,
            format
        });
    }, [pariodoEnvironment, intervalloSelezionato, dataDa, dataA, format]);

    return intervallo;
}
